import { HbrSpinner } from '@harbor/elements-react-standalone';
import React from 'react';

interface Props {
  columns: string[];
  data: { [id: string]: string[] };
  loading?: boolean;
  noHeader?: boolean;
  onRowClick?: (id: string) => void;
  maxHeight?: boolean; // one usecase for now, could add height options
}

const StbSimpleTable = ({
  columns,
  data,
  loading,
  onRowClick,
  noHeader,
  maxHeight,
}: Props) => {
  const colCount = columns.length;
  // these need to be compiled before runtime, so listing likely sizes
  const preloadTW = [
    'grid-cols-1',
    'grid-cols-2',
    'grid-cols-3',
    'grid-cols-4',
    'grid-cols-5',
    'grid-cols-6',
  ];

  return (
    <div className={`mb-4 ${maxHeight ? ' max-h-80 overflow-y-auto' : ''}`}>
      {!noHeader && (
        <div className={`grid grid-cols-${colCount}`}>
          {columns.map((col, index) => (
            <div key={index} className='text-sm font-medium'>
              {col}
            </div>
          ))}
        </div>
      )}
      {loading && <HbrSpinner size='small' />}
      {Object.keys(data).map((id) => (
        <React.Fragment key={id}>
          <div
            className={`${onRowClick ? 'hover:bg-gray-200 cursor-pointer' : ''} grid-cols-${colCount} grid`}
            onClick={onRowClick ? () => onRowClick(id) : undefined}
          >
            {data[id].map((value, index) => (
              <div key={index} className='text-sm my-1'>
                {value}
              </div>
            ))}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default StbSimpleTable;
